const descriptionMaxLength = 147;

export function getDescription({ content, fallback = '' }) {
  const firstNormalBlock = content?.find(
    // eslint-disable-next-line no-underscore-dangle
    (block) => block._type === 'block' && block.style === 'normal'
  );
  if (!firstNormalBlock) return fallback;

  const firstNormalBlockText = firstNormalBlock.children
    .map(({ text }) => text)
    .join(' ')
    .trim();

  return firstNormalBlockText.length > 0
    ? `${firstNormalBlockText.slice(0, descriptionMaxLength)}...`
    : fallback;
}
